$(function(){


    // REVEAL FIXED ATC BAR ON SCROLL PAST ADD TO CART BUTTON

    $('.fixed-minimize-btn').on('click', function(e){
        e.preventDefault();
        if(!$('.fixed-atc-bar').hasClass('revealed')){
            console.log('has revealed class')
            $('.fixed-atc-bar').removeClass('minimized');
            $('.fixed-atc-bar').addClass('revealed');
        } else {
            console.log('does not have revealed class')
            $('.fixed-atc-bar').addClass('minimized');
            $('.fixed-atc-bar').removeClass('revealed');
        }
    });
    $(window).on('scroll', function() {
        const formOffset = $('.single-product__content').offset().top + $('.single-product__content').outerHeight();
        const footerOffset = $('footer').offset().top;
        const scrollPosition = $(window).scrollTop();
        const scrollPositionBot = scrollPosition + $(window).height();

        if (scrollPosition > formOffset && scrollPositionBot < footerOffset && !$('.fixed-atc-bar').hasClass('minimized')) {
            $('.fixed-atc-bar').addClass('revealed');
        } else {
            $('.fixed-atc-bar').removeClass('revealed');
        }
    });

    var customSelect = $('.custom-select');
    var options = customSelect.find('.custom-options');
    $('.custom-select-trigger').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('open');
    });

    options.on('click', 'a', function(e) {
        e.preventDefault();
        let id = $(this).attr('id');
        $('.custom-options-value').removeClass('active-option');
        $(this).addClass('active-option');
        $(this).parent().parent().find('.custom-select-trigger').html($(this).html());
        $('.custom-select').removeClass('open');
        var originalScrollTop = $(window).scrollTop();
        $('.variant__option-item label[for='+id+']').trigger('click');
        $(window).scrollTop(originalScrollTop);
        // $('#'+id).prop('checked', true).trigger('change');
        $('.fixed-atc-bar').addClass('revealed');

    });

    $('.fixed-variant__option').each(function(){
        let activeOption = $(this).find('.custom-options-value.active-option').html();
        $(this).find('.custom-select-trigger').html(activeOption);
    })
 

    $(document).on('click', function(event) {
        if (!customSelect.is(event.target) && customSelect.has(event.target).length === 0) {
            $('.custom-select').removeClass('open');
        }
    });

    $('.fixed-atc-bar-button .fixed-atc').on('click',function(e){
        e.preventDefault();
        let form = $(this).data('prod');
        $('#'+form+'.single-product-form').find('.btn__atc').trigger('click');
    });


    // KEEP FIXED ATC BAR IN SYNC WITH THE PRODUCT FORM
    // variantChange() in theme.min.js only looks for .fixed-atc-bar-button inside the
    // product form, so availability and selected options are mirrored here instead.

    function getSelectedVariantOption() {
        let selector = '';
        $('.variant__input:checked').each(function(index){
            selector += '[option' + index + '="' + $(this).attr('value') + '"]';
        });
        if (selector === '') {
            return $('.product-variants option:selected').first();
        }
        return $('.product-variants option' + selector).first();
    }

    function syncFixedAtcBar() {
        const $variant = getSelectedVariantOption();
        const available = $variant.attr('availablity') === 'available';

        $('.fixed-atc-bar-button').toggleClass('unavailable', !available);

        $('.variant__input:checked').each(function(){
            const $match = $('.fixed-variant .custom-options-value[name="' + $(this).attr('name') + '"][id="' + $(this).attr('id') + '"]');
            if ($match.length) {
                const $fixedOption = $match.closest('.fixed-variant__option');
                $fixedOption.find('.custom-options-value').removeClass('active-option');
                $match.addClass('active-option');
                $fixedOption.find('.custom-select-trigger').html($match.html());
            }
        });

        // reset the notify form for the newly selected variant
        $('.notify-me-wrapper').each(function(){
            $(this).find('.notify-me-form').show();
            $(this).find('.notify-me-success').hide();
            $(this).find('.error-msg').html('');
        });
    }

    $('body').on('change', '.variant__input', syncFixedAtcBar);
    syncFixedAtcBar();

    $('.fixed-atc-bar-button .fixed-notify-me').on('click', function(e){
        e.preventDefault();
        const $wrapper = $('#' + $(this).data('notify'));
        if (!$wrapper.length) return;

        const target = $wrapper.offset().top - Math.max(($(window).height() - $wrapper.outerHeight()) / 2, 0);
        $('html, body').stop().animate({ scrollTop: target }, 400).promise().done(function(){
            const email = $wrapper.find('.notify-me-email:visible').get(0);
            if (email) email.focus({ preventScroll: true });
        });
    });


    // NOTIFY ME (KLAVIYO BACK IN STOCK)
    // Replaces the handler in theme.min.js, which showed the success message before the
    // request finished, never surfaced errors and let the Enter key post to /contact.

    $('body').off('click', '.notify-me-submit');
    $('body').on('submit', '.notify-me-form', function(e){
        e.preventDefault();
        const $form = $(this);
        const $wrapper = $form.closest('.notify-me-wrapper');
        const $error = $form.find('.error-msg');
        const $submit = $form.find('.notify-me-submit');
        const email = $.trim($form.find('.notify-me-email').val());
        const variantId = $form.find('.notify-me-variant').val();

        if ($submit.prop('disabled')) return;
        $error.html('');

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            $error.html('<p>Please enter a valid email address.</p>');
            return;
        }
        if (!variantId) {
            $error.html('<p>Please select an option.</p>');
            return;
        }

        const payload = {
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    profile: { data: { type: 'profile', attributes: { email: email } } },
                    channels: ['EMAIL']
                },
                relationships: {
                    variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
                }
            }
        };

        $submit.prop('disabled', true);
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + $submit.data('public-api'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
            body: JSON.stringify(payload)
        })
        .then(function(response){
            if (!response.ok) throw new Error('Klaviyo responded with ' + response.status);
            $form.hide();
            $wrapper.find('.notify-me-success').show();
        })
        .catch(function(error){
            console.error('Notify me error', error);
            $error.html('<p>Something went wrong, please try again.</p>');
        })
        .finally(function(){
            $submit.prop('disabled', false);
        });
    });




 // ================================

let compareItems = JSON.parse(localStorage.getItem('compareItems')) || [{},{},{},{}];
compareItems.forEach((item, index) => {
    index++;
    if(compareItems[index-1].handle){
        fetch(item.handle+"?section_id=main-product")
        .then((response) => response.text())
        .then((product_data) => {
            
            var product_info = $(product_data);
            var com_info = $(".compare__prod", product_info);
            $('.comparison__product-'+index).find('.compare-details-display').html(com_info);
            $('.comparison__product-'+index).addClass('compare-item-added');
        });
    }
});
$('.compare-button-trigger').on('click', function(e){
    e.preventDefault();
    var selected_product = $(this).data('handle');
    selected_product = "/products/"+ selected_product;
    fetch(selected_product+"?section_id=main-product")
      .then((response) => response.text())
      .then((product_data) => {
        if (!compareItems.some(item => item.handle === selected_product)) {
              // ADD ID TO LOCALSTORAGE

            let compareIndex = compareItems.findIndex(item => !item.handle);
            if (compareIndex === -1) {
                compareIndex = 0;
            }

            compareItems[compareIndex].handle = selected_product;
            localStorage.setItem('compareItems', JSON.stringify(compareItems));
            var product_info = $(product_data);
            var com_info = $(".compare__prod", product_info);
            var index = compareIndex + 1;
            $('.comparison__product-'+index).find('.compare-details-display').html(com_info);
            $('.comparison__product-'+index).addClass('compare-item-added');
            $('.comparison__product-'+index).find('.comparison-error').hide().html('');
            $('.compare-modal').fadeIn();
        } else {
            $('.compare-modal').fadeIn();
        }
    });

   
});

$('.comparison-select').on('change',function(){
    var compareIndex = $(this).parents('.comparison__product').data('index');
    var selected_product = $(this).find('option:selected').data('product-handle');
    selected_product = "/products/"+ selected_product;
    fetch(selected_product+"?section_id=main-product")
      .then((response) => response.text())
      .then((product_data) => {
        if (!compareItems.some(item => item.handle === selected_product)) {
              // ADD ID TO LOCALSTORAGE
            compareItems[compareIndex].handle = selected_product;
            localStorage.setItem('compareItems', JSON.stringify(compareItems));
            var product_info = $(product_data);
            var com_info = $(".compare__prod", product_info);
            $(this).parents('.comparison__product').find('.compare-details-display').html(com_info);
            $(this).parents('.comparison__product').addClass('compare-item-added');
            $(this).parents('.comparison__product').find('.comparison-error').hide().html('');
        } else {
            $(this).parents('.comparison__product').find('.comparison-error').html('<p>Product already added to compare</p>').show();
        }
        

    });
});
$(document).on('click', '.remove-compare-product', function(e) {
    e.preventDefault();
    const index = $(this).parents('.comparison__product').data('index');
    const compareIndex = index + 1;
    $('.comparison__product-'+compareIndex).find('.compare-details-display').html('');
    $('.comparison__product-'+compareIndex).removeClass('compare-item-added');
    compareItems[index].handle = '';
    localStorage.setItem('compareItems', JSON.stringify(compareItems));
});
$('.compare-button-trigger').on('click', function(e){
    e.preventDefault();
    $('.compare-modal').fadeIn();
});
$('#close-compare-modal').on('click', function(e){
    e.preventDefault();
    $('.compare-modal').fadeOut();
})


});